<template>
  <div id="shipping-multichannel" class="panel-body">
    <p class="text-size-20">ACROSS倉庫にある商品を出荷する依頼を作成することができます</p>
    <div class="mr-t-15 text-warning bg-warning font-bold" style="margin-left: 30px; width: 850px;">
      <span style="padding: 10px;">13:30までの登録は当日出荷、13:30以降の登録は翌日出荷となります。</span>
    </div>
    <div>
      <div class="mr-t-20" style="min-width: 1500px;">
        <div class="flexbox gap-15">
          <svg width="50" height="50">
            <circle cx="25" cy="25" r="20" stroke="#008cc6" stroke-width="3" fill="#008cc6" />
            <text x="50%" y="50%" text-anchor="middle" dominant-baseline="central" font-size="20" fill="#fff">1</text>
          </svg>
          <span class="font-bold text-size-16 text-primary">基本情報入力</span>
        </div>
        <div class="mr-t-10 bg-white mr-l-30" style="border: 1px solid #ccc; margin-left: 30px; padding: 10px;">
          <div class="box-delivery-name m-b-md">
            <div class="row">
              <div class="col-md-2 col-lg-1 w-150">
                <div class="delivery-name"><strong>出荷名</strong></div>
              </div>
              <div class="col-md-10 col-lg-7">
                <input type="text" :class="['form-control', shippingName ? '' : 'bg-no-input']" v-model.trim="shippingName">
                <div>※セールモンスターのみが使用する項目です。セラー様が管理しやすい名称をご入力ください。</div>
                <div v-if="validateErrors.shippingName.length" class="text-red"><b>{{ validateErrors.shippingName[0]}}</b></div>
              </div>
            </div>
          </div>
          <div class="box-origin-info-default m-b-sm">
            <div class="row">
              <div class="col-md-2 col-lg-1 w-150">
                <div class="m-b-sm"><strong>発送元情報</strong></div>
              </div>
              <div class="col-md-9 col-lg-10">
                <div v-if="shippingInfo" class="delivery-info-default">
                  <div>{{ shippingInfo.name }}</div>
                  <div>
                    {{ shippingInfo.postalCode }} &nbsp;&nbsp;&nbsp; {{ shippingInfo.address1 }} {{ shippingInfo.address2 }}
                  </div>
                  <div>{{ shippingInfo.phoneNo }}</div>
                </div>
                <a href="javascript:void(0)" class="text--underline" @click.prevent="openModalShippingMultichannelInfo()">登録・変更はこちら</a>
                <div v-if="validateErrors.shippingInfo.length" class="text-red"><b>{{ validateErrors.shippingInfo[0]}}</b></div>
              </div>
            </div>
          </div>
          <div class="m-b-md">
            <div class="row">
              <div class="col-md-2 col-lg-1 w-150">
                <div class="delivery-name"><strong>依頼番号(任意)</strong></div>
              </div>
              <div class="col-md-10 col-lg-7">
                <div class="flexbox gap-10">
                  <input type="text" class="form-control w-500" :class="[validateRequestNo() ? '' : 'bg-no-input']" v-model.trim="requestNo">
                  半角英数字、ハイフンのみ入力可
                </div>
                <div>※ショップの注文番号等をご入力ください。 送り状ラベルに表示されます。</div>
                <div v-if="validateErrors.requestNo.length" class="text-red"><b>{{ validateErrors.requestNo[0]}}</b></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mr-t-20" style="min-width: 1500px;">
        <div class="flexbox gap-15">
          <svg width="50" height="50">
            <circle cx="25" cy="25" r="20" stroke="#008cc6" stroke-width="3" fill="#008cc6" />
            <text x="50%" y="50%" text-anchor="middle" dominant-baseline="central" font-size="20" fill="#fff">2</text>
          </svg>
          <span class="font-bold text-size-16 text-primary">お届け先情報入力</span>
        </div>
        <div class="mr-t-10 bg-white mr-l-30" style="border: 1px solid #ccc; margin-left: 30px; padding: 10px; height: 150px;">
          <div v-if="deliveryInfo" class="m-b-sm">
            <div class="row">
              <div class="pd-l-15 pd-r-15">
                <b class="w-130">お届け先名：</b>
                {{ deliveryInfo.name }}
              </div>
            </div>
            <div class="row">
              <div class="pd-l-15 pd-r-15">
                <b class="w-130">郵便番号：</b>
                {{ deliveryInfo.postalCode }}
                <b class="w-130 pd-l-30">住所：</b>
                {{ deliveryInfo.address1 }} {{ deliveryInfo.address2 }}
              </div>
            </div>
            <div class="row">
              <div class="pd-l-15 pd-r-15">
                <b class="w-130">電話番号：</b>
                {{ deliveryInfo.phoneNo }}
              </div>
            </div>
          </div>
          <div v-if="validateErrors.deliveryInfo.length" class="text-red"><b>{{ validateErrors.deliveryInfo[0]}}</b></div>
          <button type="button" class="btn btn-primary check-maintenance" @click="openModalRegisterDeliveryInfo()">お届け先情報を入力</button>
        </div>
      </div>
      <div class="mr-t-20" style="min-width: 1500px;">
        <div class="flexbox gap-15">
          <svg width="50" height="50">
            <circle cx="25" cy="25" r="20" stroke="#008cc6" stroke-width="3" fill="#008cc6" />
            <text x="50%" y="50%" text-anchor="middle" dominant-baseline="central" font-size="20" fill="#fff">3</text>
          </svg>
          <span class="font-bold text-size-16 text-primary">商品情報入力</span>
        </div>
        <div id="product-input" class="mr-t-10 bg-white mr-l-30" style="border: 1px solid #ccc; margin-left: 30px; padding: 10px;">
          <fixed-header v-show="isShowFixedHeader" :textBtnRegister="'出荷依頼'" @handleClickAdd="openModalProductAdd()" @handleClickRegister="submitValidate()"/>
          <p class="">出荷する商品を選択し、商品情報を入力してください。</p>
          <button type="button" class="btn btn-primary check-maintenance" @click.prevent="openModalProductAdd()">商品選択</button>
          <div v-if="selectedProducts.length" class="table-selected-products">
            <table class="full-width">
              <thead>
                <tr>
                  <th class="text-center w-150">出荷する商品</th>
                  <th style="min-width: 500px;"></th>
                  <th class="text-right w-200">ACROSS在庫数</th>
                  <th class="w-120">出荷予定数</th>
                  <th class="text-center w-100">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(selectedProduct, index) in selectedProducts" :key="index">
                  <td class="text-center">
                    <div class="box-selected-product-image w-40">
                      <img :src="selectedProduct.image" alt="" class="selected-product-image img-responsive">
                    </div>
                    <div :class="`box-delivery-judgment-status ${getJudgmentStatusClass(selectedProduct.status)}`">{{ selectedProduct.status_str }}</div>
                  </td>
                  <td>
                    <div class="m-b-xs">{{ selectedProduct.itemName }}</div>
                    <div><b>ASIN：</b>{{selectedProduct.asin}} / <b>SKU：</b>{{ selectedProduct.sku }} </div>
                    <div><b>商品ID：</b>{{selectedProduct.itemId}} / <b>商品ラベル：</b>{{ selectedProduct.goodsLabel }}</div>
                  </td>
                  <td colspan="2">
                    <tr>
                      <td class="text-right w-200 no-borders no-padding">
                        <span class="">{{ formatNumber(selectedProduct.acrossQuantity) }} 個</span>
                      </td>
                      <td class="no-borders">
                        <input type="text" class="form-control expected-delivery-number text-right mr-l-10" :class="parseInt(selectedProduct.quantity) && parseInt(selectedProduct.quantity) <= parseInt(selectedProduct.acrossQuantity) ? '' : 'bg-no-input'" v-model="selectedProduct.quantity" @input="selectedProduct.quantity = handleInputQuantity(selectedProduct.quantity)">
                      </td>
                    </tr>
                    <div v-if="validateErrors.quantity[selectedProduct.itemId] && validateErrors.quantity[selectedProduct.itemId].length" class="text-red text-right"><b>{{ validateErrors.quantity[selectedProduct.itemId][0]}}</b></div>
                  </td>
                  <td class="text-center">
                    <button type="button" class="btn btn-delete-selected-product check-maintenance" @click.prevent="deleteSelectedProduct(selectedProduct)">削除</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="text-center m-b-md m-t-md">
              <button type="button" class="btn btn-primary custom-btn check-maintenance" @click.prevent="submitValidate">
                出荷依頼
                <i class="fa fa-check fa-lg mr-l-5" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div v-else class="empty-products text-center">
            <h3 class="m-b-xl text-center"><strong>商品選択より、出荷する商品を選択してください。</strong></h3>
          </div>
        </div>
      </div>
    </div>
    <shipping-multi-channel-product-add
      v-if="openProductAddModal"
      ref="shippingMultiProductAddModal"
      :selectedProducts="selectedProducts"
      @onHandleSearch="onHandleSearch"
      @close="closeModalProductAdd"
      @handleSelectedProduct="handleSelectedProduct"
      @handleSelectedProducts="handleSelectedProducts"
    />
    <modal-alert
      v-if="openAlertValidateFailsModal"
      :message="alertValidateFailsMessage"
      :customHide="true"
      @close="closeModalAlertValidateFails"
    />
    <modal-confirm
      v-if="openProductsAddConfirmModal"
      :message="productsAddConfirmMessage"
      @confirm="updateShippingMultichannel"
      @close="closeModalConfirmProductsAdd"
    />
    <modal-alert
      v-if="openAlertProductsAddedModal"
      :message="alertProductsAddedMessage"
      :customHide="true"
      :modalWidth="550"
      @close="closeModalAlertProductsAdded"
    />
    <shipping-multichannel-info-modal
      v-if="openShippingMultichannelInfoModal"
      ref="shippingMultichannelInfoModal"
      @close="closeModalShippingMultichannelInfo"
      @openModalRegisterShippingInfo="openModalRegisterShippingInfo"
      @setDefaultInfoSuccess="updateShippingInfo"
    />
    <register-shipping-info-modal
      v-if="openRegisterShippingInfoModal"
      ref="registerShippingInfoModal"
      @close="closeModalRegisterShippingInfo"
    />
    <register-delivery-info-modal
      v-if="openRegisterDeliveryInfoModal"
      ref="registerDeliveryInfoModal"
      :deliveryInfo="deliveryInfo"
      @close="closeModalRegisterDeliveryInfo"
      @updatedDeliveryInfo="updatedDeliveryInfo"
    />
  </div>
</template>

<script>
import Util from '@/common/utility'
import moment from 'moment'
import ModalAlert from '@/components/ModalAlert'
import ModalConfirm from '@/components/ModalConfirm'
import ShippingMultiChannelProductAdd from '@/view/warehouseAcross/components/ShippingMultiChannelProductAdd'
import ShippingMultichannelInfoModal from '@/view/warehouseAcross/components/ShippingMultichannelInfoModal'
import RegisterShippingInfoModal from '@/view/warehouseAcross/components/RegisterShippingInfoModal'
import RegisterDeliveryInfoModal from '@/view/warehouseAcross/components/RegisterDeliveryInfoModal'
import FixedHeader from './components/FixedHeader'
import WarehouseAcrossService from '@/services/warehouseacrossservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    ModalAlert,
    ModalConfirm,
    ShippingMultiChannelProductAdd,
    RegisterShippingInfoModal,
    RegisterDeliveryInfoModal,
    ShippingMultichannelInfoModal,
    FixedHeader
  },
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loader: null,
      openShippingMultichannelInfoModal: false,
      openProductsAddConfirmModal: false,
      openAlertProductsAddedModal: false,
      openProductAddModal: false,
      openAlertValidateFailsModal: false,
      openRegisterShippingInfoModal: false,
      openRegisterDeliveryInfoModal: false,
      isShowFixedHeader: false,
      shippingNo: null,
      shippingId: null,
      shippingName: null,
      requestNo: null,
      deliveryInfo: null,
      shippingInfo: null,
      validateErrors: {
        shippingName: [],
        requestNo: [],
        quantity: {},
        shippingInfo: [],
        deliveryInfo: []
      },
      selectedProducts: [],
      alertValidateFailsMessage: '入力エラーです。<br/>入力内容を確認、修正後にご登録をお願いします。',
      productsAddConfirmMessage: '出荷情報を登録します。 よろしいですか？'
    }
  },
  created () {
    if (this.$route.query.shippingNo && this.$route.query.shippingId) {
      this.getDetail(this.$route.query.shippingNo, this.$route.query.shippingId)
    } else {
      this.$router.push('/not-found')
    }
  },
  computed: {
    alertProductsAddedMessage () {
      return `
        出荷情報を受付けました。 <br>
        出荷管理番号 ${this.shippingNo} <br> <br>
        <div>
          ご登録頂いた情報は、納品状況照会画面より確認いただけます。<br>
          また、出荷が完了した際はメールにて通知させていただきます。<br>
        </div>
      `
    }
  },
  methods: {
    openModalShippingMultichannelInfo () {
      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.multi_channel_shipping.click_regis_or_update_shipping_info_btn,
        properties: {}
      }
      EventService.postTrackLog(logParams)
      this.openShippingMultichannelInfoModal = true
    },
    closeModalShippingMultichannelInfo () {
      $('#shipping-info-modal').modal('hide')
      this.openShippingMultichannelInfoModal = false
    },
    openModalRegisterShippingInfo () {
      this.closeModalShippingMultichannelInfo()
      this.openRegisterShippingInfoModal = true
    },
    closeModalRegisterShippingInfo () {
      $('#register-shipping-info-modal').modal('hide')
      this.openRegisterShippingInfoModal = false
    },
    openModalRegisterDeliveryInfo () {
      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.multi_channel_shipping.click_input_receipt_info_btn,
        properties: {}
      }
      EventService.postTrackLog(logParams)
      this.openRegisterDeliveryInfoModal = true
    },
    closeModalRegisterDeliveryInfo () {
      $('#register-delivery-info-modal').modal('hide')
      this.openRegisterDeliveryInfoModal = false
    },
    updatedDeliveryInfo (deliveryInfo) {
      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.multi_channel_shipping.click_regis_receipt_info_btn,
        properties: deliveryInfo
      }
      EventService.postTrackLog(logParams)
      this.deliveryInfo = deliveryInfo
      this.closeModalRegisterDeliveryInfo()
    },
    closeGetLatestProductModal () {
      $('#myModal').modal('hide')
      this.showGetLatestProductModal = false
      this.getLatestProduct()
    },
    closeModalProductAdd () {
      $('#shipping-product-add-modal').modal('hide')
      this.openProductAddModal = false
    },
    openModalAlertValidateFails () {
      this.openAlertValidateFailsModal = true
    },
    closeModalAlertValidateFails () {
      $('#myModal').modal('hide')
      this.openAlertValidateFailsModal = false
    },
    openModalConfirmProductsAdd () {
      if (this.isValidateFails) return
      this.openProductsAddConfirmModal = true
    },
    closeModalConfirmProductsAdd () {
      $('#confirm-alert').modal('hide')
      this.openProductsAddConfirmModal = false
    },
    openModalAlertProductsAdded () {
      this.openAlertProductsAddedModal = true
    },
    closeModalAlertProductsAdded () {
      $('#myModal').modal('hide')
      this.openAlertProductsAddedModal = false
      this.shippingName = null
      this.shippingNo = null
      this.$router.push({
        name: 'Warehouse across',
        params: {
          tab: 'shipping',
          subTab: 'shipping-status-inquiry'
        }
      })
    },
    closeUpgradePlanModal () {
      this.isShowUpgradePlanModal = false
      $('#upgrade-plan-modal').modal('hide')
    },
    getJudgmentStatusClass (judgmentStatusCode) {
      let classes = ''
      let statusSuccess = ['2']
      let statusWarning = ['0', '1']
      let statusDanger = ['8', '9']
      if (!judgmentStatusCode) {
        return 'judgment-status-not-listed'
      }
      if (statusSuccess.includes(judgmentStatusCode)) {
        classes = 'judgment-status-success'
      } else if (statusWarning.includes(judgmentStatusCode)) {
        classes = 'judgment-status-warning'
      } else if (statusDanger.includes(judgmentStatusCode)) {
        classes = 'judgment-status-danger'
      }
      return classes
    },
    onHandleSearch (keywordValue) {
      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.multi_channel_shipping.click_search_btn,
        properties: {
          keyword: keywordValue
        }
      }
      EventService.postTrackLog(logParams)
    },
    deleteSelectedProduct (product) {
      this.selectedProducts = this.selectedProducts.filter(item => item.itemId !== product.itemId)
    },
    handleSelectedProduct (product) {
      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.multi_channel_shipping.click_add_product_btn,
        properties: {
          itemId: product.itemId
        }
      }
      EventService.postTrackLog(logParams)

      this.selectedProducts.push(product)
    },
    handleSelectedProducts (products) {
      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.multi_channel_shipping.click_add_products_btn,
        properties: {
          itemId: products.map(p => p.itemId)
        }
      }
      EventService.postTrackLog(logParams)

      this.selectedProducts = [...this.selectedProducts, ...products]
    },
    formatDate (value) {
      return value ? moment(value).format('YYYY/MM/DD') : ''
    },
    formatNumber (number) {
      return Util.formatMoney(number)
    },
    openModalProductAdd () {
      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.multi_channel_shipping.click_select_product_btn,
        properties: {}
      }
      EventService.postTrackLog(logParams)
      this.openProductAddModal = true
    },
    async submitValidate () {
      this.loader = this.$loading.show()
      let params = {
        shippingGoods: this.selectedProducts
      }
      await WarehouseAcrossService.getShippingStockInfo(params)
        .then((response) => {
          this.selectedProducts = response.data
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })

      await this.validateInput()

      this.loader && this.loader.hide()
    },
    validateInput () {
      let required = '※必ず入力してください'
      let validateMin = '※1以上の数値を入力してください'
      let validateMax = '※ACROSS在庫数以内で入力してください'
      let validateRequestNumber = '※半角英字、半角数字またはハイフンのみをご入力ください。'
      this.isValidateFails = false

      if (!this.shippingName || !this.shippingName.trim()) {
        this.validateErrors.shippingName.push(required)
        this.isValidateFails = true
      } else {
        this.validateErrors.shippingName = []
      }
      if (this.requestNo && !this.validateRequestNo()) {
        this.validateErrors.requestNo.push(validateRequestNumber)
        this.isValidateFails = true
      } else {
        this.validateErrors.requestNo = []
      }
      if (!this.shippingInfo || !Object.keys(this.shippingInfo).length) {
        this.validateErrors.shippingInfo.push(required)
        this.isValidateFails = true
      } else {
        this.validateErrors.shippingInfo = []
      }
      if (!this.deliveryInfo || !Object.keys(this.deliveryInfo).length) {
        this.validateErrors.deliveryInfo.push(required)
        this.isValidateFails = true
      } else {
        this.validateErrors.deliveryInfo = []
      }

      this.selectedProducts.forEach((product) => {
        let quantity = parseInt(product.quantity)
        let itemId = product.itemId
        this.validateErrors.quantity[itemId] = []
        if (isNaN(quantity)) {
          this.validateErrors.quantity[itemId][0] = required
          this.isValidateFails = true
        } else if (quantity === 0) {
          this.validateErrors.quantity[itemId][0] = validateMin
          this.isValidateFails = true
        } else if (quantity > product.acrossQuantity) {
          this.validateErrors.quantity[itemId][0] = validateMax
          this.isValidateFails = true
        } else {
          delete this.validateErrors.quantity[itemId]
        }
      })

      if (this.isValidateFails) {
        this.openModalAlertValidateFails()
      } else {
        this.openModalConfirmProductsAdd()
      }
    },
    updateShippingMultichannel () {
      if (this.isValidateFails) return

      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.multi_channel_shipping.click_request_shipping_btn,
        properties: {
          shippingNo: this.shippingNo,
          shippingId: this.shippingId
        }
      }
      EventService.postTrackLog(logParams)

      this.loader = this.$loading.show()

      let params = {
        shippingNo: this.shippingNo,
        shippingId: this.shippingId,
        shippingGoods: this.selectedProducts,
        shippingName: this.shippingName,
        requestNo: this.requestNo,
        shippingInfo: this.shippingInfo,
        deliveryInfo: this.deliveryInfo
      }
      WarehouseAcrossService.updateShippingMultichannel(params)
        .then((response) => {
          this.closeModalConfirmProductsAdd()
          this.loader && this.loader.hide()
          this.openModalAlertProductsAdded()
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    async getDetail (shippingNo, shippingId) {
      this.loader = this.$loading.show()
      let params = {
        shippingNo: shippingNo,
        shippingId: shippingId
      }
      await WarehouseAcrossService.getShippingMultiDetail(params)
        .then((response) => {
          this.shippingNo = response.data.shippingNo
          this.shippingId = response.data.shippingId
          this.requestNo = response.data.requestNo
          this.shippingName = response.data.shippingName
          this.shippingInfo = response.data.shippingInfo
          this.deliveryInfo = response.data.deliveryInfo
          this.selectedProducts = response.data.shippingGoods
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    validateRequestNo () {
      if (!this.requestNo) {
        return true
      }
      const regex = /^[a-zA-Z0-9-ｰー]{1,100}$/
      if (regex.test(this.requestNo)) {
        return true
      } else {
        return false
      }
    },
    updateShippingInfo (data) {
      if (data) {
        this.shippingInfo = {
          name: data.name,
          postalCode: data.postalCode,
          address1: data.address1,
          address2: data.address2,
          phoneNo: data.phoneNo
        }
      }
    },
    handleScroll () {
      const fixedHeader = document.getElementById('product-input')
      const initialOffset = fixedHeader.getBoundingClientRect().top + window.scrollY
      this.isShowFixedHeader = window.scrollY >= initialOffset
    },
    handleInputQuantity (value) {
      return value.replace(/[^0-9]/g, '').replace(/^0+/, '')
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  unmouted () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style scoped>
.step-rectangle {
  border: 2px solid #008cc6;
  border-radius: 8px;
  padding: 5px;
  width: 350px;
  height: 70px;
}
.text-primary {
  color: #008cc6;
}
.table-selected-products {
  margin-top: 10px;
  /* overflow: auto; */
  padding: 0
}
.table-selected-products table {
  border: 1px solid #ccc
}
.table-selected-products th, .table-selected-products td{
  padding: 5px 10px;
  min-width: 120px;
  height: auto;
  border-bottom: 1px solid #ccc;
}
.table-selected-products th {
  color: #595959;
  background-color: #deebf7;
}
.td-vertical-top {
  vertical-align: top;
}
#shipping-multichannel {
  overflow: auto;
}
.judgment-status-not-listed {
  color: #f2f2f2;
  background-color: #a6a6a6;
}
.custom-btn {
  font-size: 20px;
  padding: 10px 50px;
  border-radius: 8px;
  background-color: #0070c0;
}
.text-warning {
  background-color: #fff2cc;
}
.bg-warning {
  color: #843c0b;
}
</style>
<style>
#shipping-multichannel .bg-no-input {
  background-color: #fdefef !important;
}
#shipping-multichannel .row {
  margin-left: -15px;
  margin-right: -15px;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAcross/EditMultiChannelShipping.vue